import { handleAgentTestChangeCurrentAgent } from './agent-test-change-current-agent';
import { handleAgentTestFieldsChanged } from './agent-test-fields-changed';
import { handleAgentTestMessage } from './agent-test-message';
import { handleAgentTestStreamMessage } from './agent-test-stream-message';
import { handleAgentTestSwitchAgent } from './agent-test-switch-agent';

export const agentTestHandlers = () => [
  handleAgentTestSwitchAgent(),
  handleAgentTestChangeCurrentAgent(),
  handleAgentTestStreamMessage(),
  handleAgentTestMessage(),
  handleAgentTestFieldsChanged(),
];
